/* src/app/modules/user/partnersequity/reserve/reserve-form.component.css */
.rsv-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 56px 32px;
}
.rsv-loading__dots {
  display: flex;
  gap: 8px;
}
.rsv-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.3;
  animation: rsv-pulse 1.2s ease-in-out infinite;
}
.rsv-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.rsv-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes rsv-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  flex-shrink: 0;
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dlg-hdr__icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dlg-hdr__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #e3fd64;
}
.dlg-hdr__title > div > span {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
  line-height: 1.3;
}
.dlg-hdr__sub {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
  margin-top: 1px;
}
.dlg-hdr__close {
  color: #6b7280;
  flex-shrink: 0;
}
.rsv-import-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #fff8e6;
  border: 1px solid #f4fec1;
  border-radius: 8px;
  margin-bottom: 16px;
}
.rsv-import-banner mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #e3fd64;
  flex-shrink: 0;
}
.rsv-import-banner__label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #92400e;
}
.rsv-import-banner__value {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #1a1d23;
}
.rsv-body {
  padding: 24px 24px 8px !important;
  min-width: 380px;
}
.rsv-suffix {
  font-size: 14px;
  color: #6b7280;
  padding-right: 4px;
}
.dlg-actions {
  padding: 12px 20px !important;
  border-top: 1px solid #e5e7eb;
  gap: 8px;
}
.rsv-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
.rsv-btn-save mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 4px;
}
/*# sourceMappingURL=reserve-form.component.css.map */
